import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["metadataId", "headline", "onUseTemplateClick", "templateActions"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Box, Button, Heading } from '@miro-site/core';
import EditableTemplatePreview from './EditableTemplatePreview';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MediaContainer = styled(Box).withConfig({
  displayName: "EditableTemplateHeader__MediaContainer",
  componentId: "sc-16n6cme-0"
})(["", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.normalizeStyles({
    borderRadius: 8,
    overflow: 'hidden',
    '& iframe': {
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      border: 'none'
    }
  });
});
var EditableTemplateHeader = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var metadataId = _ref2.metadataId,
      headline = _ref2.headline,
      onUseTemplateClick = _ref2.onUseTemplateClick,
      templateActions = _ref2.templateActions,
      props = _objectWithoutProperties(_ref2, _excluded);

  var _useState = useState(),
      wrapperStyles = _useState[0],
      setWrapperStyles = _useState[1];

  var _useState2 = useState(),
      headerStyles = _useState2[0],
      setHeaderStyles = _useState2[1];

  var _useState3 = useState(),
      previewStyles = _useState3[0],
      setPreviewStyles = _useState3[1];

  useEffect(function () {
    setWrapperStyles({
      display: [undefined, 'flex', 'flex', 'flex'],
      flexWrap: [undefined, 'nowrap', 'nowrap', 'nowrap'],
      flexDirection: [undefined, 'column', 'column', 'column']
    });
    setHeaderStyles({
      display: [undefined, 'flex', 'flex', 'flex'],
      flexWrap: [undefined, 'nowrap', 'nowrap', 'nowrap'],
      flexDirection: [undefined, 'row', 'row', 'row'],
      alignItems: [undefined, 'center', 'center', 'center'],
      justifyContent: [undefined, 'space-between', 'space-between', 'space-between']
    });
    setPreviewStyles({
      position: 'relative',
      borderRadius: 8,
      width: [325, '100%', '100%', '100%'],
      height: '100%'
    });
  }, []);
  return /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
    ref: ref,
    "data-test-id": true,
    "data-track-place": "template-page-header",
    $pb: 0,
    $styles: wrapperStyles
  }, props), {}, {
    children: [/*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
      $pb: [20, 28, 28, 28],
      $styles: headerStyles
    }, props), {}, {
      children: [/*#__PURE__*/_jsx(Heading, {
        as: "h1",
        $variant: "h2",
        $mb: [20, 24, 24, 24],
        children: headline
      }), /*#__PURE__*/_jsx(Button, {
        "data-track-id": "use-template",
        "data-template-id": metadataId,
        $buttonType: "primary",
        $size: "medium",
        $withArrow: true,
        onClick: onUseTemplateClick,
        $mb: [12, 15],
        children: templateActions.USE_TEMPLATE
      })]
    })), /*#__PURE__*/_jsx(Box, {
      $mb: [40, null, null, null],
      $styles: previewStyles,
      children: /*#__PURE__*/_jsx(MediaContainer, {
        children: /*#__PURE__*/_jsx(EditableTemplatePreview, {})
      })
    })]
  }));
});
export default EditableTemplateHeader;